import React, { Component } from 'react';
import Axios from 'axios'
import Dialog from "@material-ui/core/Dialog";
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Autocomplete from '@material-ui/lab/Autocomplete';
import './../../../assets/css/userDetailReport.css';
import { API_CONFIG } from "../../../config/config.jsx";
import {  Grid } from '@material-ui/core';


class UpdateStoreOwner extends Component {
    constructor(props) {
        super(props)
        this.state = {
            drawerflag: this.props.drawerflag,
            deleteflag: false,
            loading: false,
            deviceId: '',
            boxId: '',
            open: false,
            usersResponse:[],
            selectedValue: ''

        }
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };
    componentWillMount() {
        this.setState({
            drawerflag: this.props.drawerflag
        })
    }

    drawerdisplay() {
        this.setState({
            drawerflag: !this.state.drawerflag
        });
    }
    updateUserData = (boxId = '') => {
        const { getPowebankReport, closeDialogBox, startLoading } = this.props;
        const token = sessionStorage.getItem("plugoAuthKey");
        const userId = sessionStorage.getItem("plugoUserId");
        startLoading()
        Axios.post(`${API_CONFIG.HOST}/store-owner/${boxId}/map/${this.state.selectedValue}`,{}, {
            headers: {
                Authorization: `Bearer ${token}`,
                "X-USER-ID": userId,
              },
        }).then(res => {
            closeDialogBox();
            getPowebankReport();
        })
        .catch(err => console.log(err))
    }

    componentDidMount() {
        const token = sessionStorage.getItem("plugoAuthKey");
        const userId = sessionStorage.getItem("plugoUserId");
        Axios.get(`${API_CONFIG.HOST}/user`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "X-USER-ID": userId,
              },
        }).then(res => {
            this.setState({
                usersResponse: res.data,
            })
        })
        .catch(err => console.log(err))

    }

    render() {
        const { classes, closeDialogBox, drawerflag, data: {
       
            name,
            id
        } = {} } = this.props;

        return (
          <div>
            <Dialog
              open={drawerflag}
              onClose={closeDialogBox}
              maxWidth="lg"
              
            >
            <DialogTitle> Update Store Owner</DialogTitle>
              <DialogContent>
              {/* <Box sx={{ mb: 4}}>
              <Typography variant="h5" gutterBottom >
                 
                </Typography>
              </Box> */}
                
                <Grid container rowGap={3}>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: "5px",
                       
                      }}
                    >
                      <InputLabel >
                        Store Name :
                      </InputLabel>
                      <Box sx={{ mb: 1}}>
                      <Typography sx={{ fontWeight: "bold" }}>
                        {name}
                      </Typography>
              </Box>
                     
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: "5px",
                        
                      }}
                    >
                      <InputLabel >BUID :</InputLabel>
                      <Box sx={{ mb: 1}}>
                      <Autocomplete
                        id="combo-box-demo"
                        size="small"
                        options={this.state.usersResponse}
                        getOptionLabel={(option) => option.user.buid || ""}
                        style={{ width: 300, mb: 1 }}
                        onChange={(event, newValue) => {
                          this.setState({ selectedValue: newValue.user.id });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="BUID"
                            variant="outlined"
                          />
                        )}
                      />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={closeDialogBox} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={() => this.updateUserData(id)}
                  color="primary"
                >
                  Update
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        );
    }
}

export default UpdateStoreOwner;